export default {
  indicators: {
    global: {},
    personal: {},
    loading: false
  }
};
